import * as Cookies from "js-cookie";
import * as Base64 from "js-base64";

const domain = () => {
  return window.location.hostname;
};

export default {
  getItem: key => {
    const value = Cookies.get(key);
    try {
      return Base64.decode(value);
    } catch {
      return value;
    }
  },
  setItem: (key, value) =>
    Cookies.set(key, Base64.encode(value), domain && { domain: domain() }),
  removeItem: key => Cookies.remove(key, { domain: domain() })
};
